import { getIframeCommunication } from '../../../helpers';
import { IFRAME_NAME } from '../../../constants';
export class WorkerChannelProviderService {
    constructor(channelLabel, systemDispatcher, iframeUrl) {
        this.topicListeners = new Map();
        this.disconnectionHandler = () => null;
        this.channelLabel = channelLabel;
        this.iframeSrc = new URL(iframeUrl);
        this.$iframeCommunication = getIframeCommunication(IFRAME_NAME, this.iframeSrc);
        this.systemDispatcher = systemDispatcher;
    }
    triggerRegisteredTopic(action) {
        var _a;
        (_a = this.topicListeners.get(action.topic)) === null || _a === void 0 ? void 0 : _a(action);
    }
    async dispatch(topic, payload) {
        const action = {
            channel: this.channelLabel,
            version: '1.0.0',
            topic,
            payload,
        };
        this.$iframeCommunication.contentWindow.postMessage(action, this.iframeSrc.origin);
    }
    onConnection(listener) {
        this.connectionHandler = listener;
    }
    triggerDisconnection() {
        var _a;
        (_a = this.disconnectionHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    async disconnect() {
        await this.systemDispatcher('channelUnsubscriptionRequest', this.channelLabel);
        return Promise.resolve();
    }
    onDisconnection(cb) {
        this.disconnectionHandler = cb;
    }
    triggerConnection() {
        var _a;
        (_a = this.connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    async register(topic, listener) {
        this.topicListeners.set(topic, listener);
    }
    async unregister(topic) {
        this.topicListeners.delete(topic);
    }
}
